import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { StocksSharedModule } from 'src/app/shared/components/stocks/stocks-shared.module';
import { ProductBatchInactiveListComponent } from './product-batch-inactive-list/product-batch-inactive-list.component';

// 獨立小模組: 供 LayoutModule/ProductModule 的庫存警示 Dialog「閒置批號」頁籤
// 與 ProductBatchModule 的進頁停用提醒 dialog 共用 (仿 StockRoomBatchListModule 拆法)
@NgModule({
  declarations: [ProductBatchInactiveListComponent],
  imports: [SharedModule, StocksSharedModule],
  exports: [ProductBatchInactiveListComponent],
})
export class ProductBatchInactiveListModule { }
